import * as React from 'react'

import { pageTypes } from '../utils/pageTypes'

export const boardContextDefault = {
  nodes: [],
}

export const BoardContext = React.createContext(boardContextDefault)
